import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
  msj: string;
  icon?: string;
  titulo?: string;
  botonAceptar?: string;
  botonCancelar?: string;
  destructivo?: boolean;
  /** Solo botón Aceptar (avisos que no se pueden cancelar). */
  ocultarCancelar?: boolean;
  /**
   * Toggle opcional bajo el mensaje; `cambio` se llama en cada cambio, sin esperar a Aceptar.
   * `detalle` da el texto mostrado a su derecha según el valor actual.
   */
  toggle?: { etiqueta: string; valor: boolean; tooltip?: string; cambio?: (valor: boolean) => void; detalle?: (valor: boolean) => string };
}

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss'
})
export class ConfirmDialogComponent implements OnInit{

  public msj = '';
  public icon = 'warning_amber';
  public titulo = 'Confirmar';
  public botonAceptar = 'Aceptar';
  public botonCancelar = 'Cancelar';
  public destructivo = false;
  public ocultarCancelar = false;

  constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ){

  }
  ngOnInit(): void {
    this.msj = this.data?.msj ?? '';
    this.icon = this.data?.icon?.trim() ? this.data.icon : 'warning_amber';
    this.titulo = this.data?.titulo?.trim() ? this.data.titulo : 'Confirmar';
    this.botonAceptar = this.data?.botonAceptar?.trim() ? this.data.botonAceptar : 'Aceptar';
    this.botonCancelar = this.data?.botonCancelar?.trim() ? this.data.botonCancelar : 'Cancelar';
    this.destructivo = !!this.data?.destructivo;
    this.ocultarCancelar = !!this.data?.ocultarCancelar;
  }

  aceptar(){
    this.dialogRef.close(true);
  }
  cancelar(){
    this.dialogRef.close(false);
  }

}
